export default "__VITE_ASSET__D5a9Apr4__"